import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[phonePopover]',
})
export class PhonePopoverDirective {
  @Input('phonePopover') phoneNumber!: string;

  private popoverEl!: HTMLElement;
  private hideTimeout: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    this.createPopover();
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.hideTimeout = setTimeout(() => this.removePopover(), 300);
  }

  private createPopover() {
    if (this.popoverEl) return;

    this.popoverEl = this.renderer.createElement('div');
    this.renderer.addClass(this.popoverEl, 'custom-popover');

    this.popoverEl.innerHTML = `
      <div class="popover-content">
        <span>${this.phoneNumber}</span>
        <i class="pi pi-copy copy-icon"></i>
      </div>
    `;

    this.renderer.appendChild(document.body, this.popoverEl);

    const rect = this.el.nativeElement.getBoundingClientRect();

    this.renderer.setStyle(this.popoverEl, 'top', `${rect.top - 45}px`);
    this.renderer.setStyle(this.popoverEl, 'left', `${rect.left-10}px`);

    this.popoverEl.addEventListener('mouseenter', () => {
      clearTimeout(this.hideTimeout);
    });

    this.popoverEl.addEventListener('mouseleave', () => {
      this.removePopover();
    });

    this.popoverEl
      .querySelector('.copy-btn')
      ?.addEventListener('click', () => {
        navigator.clipboard.writeText(this.phoneNumber);
        /*(this.popoverEl.querySelector('.copy-btn') as HTMLElement).innerText =
          '<i class="fi fi-sr-copy"></i>';*/

        const icon = this.popoverEl.querySelector('.copy-btn i') as HTMLElement;

        icon.className = 'fi fi-sr-copy';
      });
  }

  private removePopover() {
    if (this.popoverEl) {
      this.renderer.removeChild(document.body, this.popoverEl);
      this.popoverEl = null!;
    }
  }
}
